import { RestResponseGetHistoricalPnL } from '@katanaperps/katana-perps-sdk';
import React, { Suspense, lazy } from 'react';
import styled from 'styled-components';

import { useSelector } from '#/reduxState/storeCore';

const PortfolioChartCore = lazy(() => import('./PortfolioChartCore'));

const Title = styled.div`
  padding: 16px 8px;
  color: #74777d;
`;

export default function PortfolioChart({
  portfolioData,
  lastEquity,
  titleOverride,
}: {
  portfolioData: RestResponseGetHistoricalPnL | undefined;
  lastEquity: string | undefined;
  titleOverride?: string;
}) {
  const isMobile = useSelector(state => state.screen.isMobile);
  const containerHeight = isMobile ? 150 : 230;

  return (
    <>
      <Title>{titleOverride ?? 'PORTFOLIO VALUE'}</Title>
      <Suspense fallback={<div style={{ height: containerHeight }} />}>
        <PortfolioChartCore
          lastEquity={lastEquity}
          portfolioData={portfolioData}
          height={containerHeight}
        />
      </Suspense>
    </>
  );
}
